module.exports = __webpack_public_path__ + "img/certificate-EC-55-65.7ea53c74.jpg";